module.exports = __webpack_public_path__ + "img/IMG_2706.d28edc00.jpg";